<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let page = 1;
  export let totalItems = 0;
  export let pageSize = 20;

  const dispatch = createEventDispatcher<{ change: number }>();
  $: totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  function goTo(nextPage: number) {
    if (nextPage < 1 || nextPage > totalPages || nextPage === page) return;
    dispatch('change', nextPage);
  }
</script>

{#if totalItems > pageSize}
  <div class="ui center aligned basic segment">
    <button class="ui button" disabled={page <= 1} on:click={() => goTo(page - 1)}>Previous</button>
    <span class="page-label">Page {page} of {totalPages} ({totalItems})</span>
    <button class="ui button" disabled={page >= totalPages} on:click={() => goTo(page + 1)}>Next</button>
  </div>
{/if}

<style>
  .page-label { margin: 0 0.75rem; }
</style>
